var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMountains(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 363.5,
    cy: 158.5,
    r: 47.5,
    fill: "#E9B000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.756 221.786 138 414h266L280.244 221.786c-4.109-6.381-14.379-6.381-18.488 0z",
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.025 154.462 302 414h359L493.975 154.462c-5.544-8.616-19.406-8.616-24.95 0z",
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M619.27 215.931 489 414h280L638.73 215.931c-4.325-6.575-15.135-6.575-19.46 0z",
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m234 385.968 26.053 16.819 25.724-16.819L260.053 321 234 385.968z",
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E1E4E5",
    strokeWidth: 4,
    d: "M260.404 369.149V414m-16.007-35.266 16.163 11.547"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m359 385.968 26.053 16.819 25.724-16.819L385.053 321 359 385.968z",
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E1E4E5",
    strokeWidth: 4,
    d: "M385.404 369.149V414m-16.007-35.266 16.163 11.547"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m429 385.968 26.053 16.819 25.724-16.819L455.053 321 429 385.968z",
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E1E4E5",
    strokeWidth: 4,
    d: "M455.404 369.149V414m-16.007-35.266 16.163 11.547"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m499 379.35 32.204 20.79L563 379.35l-31.796-80.305L499 379.35z",
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E1E4E5",
    strokeWidth: 4,
    d: "M531.166 358.56V414m-19.589-43.207 19.979 14.272"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m615 391.092 21.291 13.745 21.021-13.745L636.291 338 615 391.092z",
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E1E4E5",
    strokeWidth: 4,
    d: "M636.943 377.347V414m-13.234-29.117 13.209 9.436"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m706 391.092 21.291 13.745 21.021-13.745L727.291 338 706 391.092z",
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E1E4E5",
    strokeWidth: 4,
    d: "M727.943 377.347V414m-13.234-29.117 13.209 9.436M101 414h697m-697 27h214m40 0h133m32 0h66m43 0h66m-546 55h214m40 0h133m32 0h66m43 0h66m55-25H584m-40 0H411m-32 0h-66m-43 0h-66"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M702.528 146.211c9.592 0 5.104-15.209-7.048-11.576-.672-21.119-35.095-36.57-49.329-8.087-4.024-3.184-13.061 2.831-11.06 8.087-4.47.381-7.987.898-10.723 1.583-6.317 1.581-5.067 9.922 1.445 9.864l76.715.129zm-378.227 88c9.592 0 5.104-15.209-7.047-11.576-.673-21.119-35.096-36.57-49.329-8.087-4.025-3.184-13.062 2.831-11.06 8.087-4.471.381-7.987.898-10.724 1.583-6.317 1.581-5.067 9.922 1.445 9.864l76.715.129zm219.483-61.87h51.622c4.615 0 6.604-6.021 2.827-8.692a9.177 9.177 0 0 0-.16-.113c-5.377-3.724-12.435-3.386-12.435-3.386S584.631 140 565.643 140c-17.167 0-24.013 16.978-26.482 26.331-.802 3.039 1.503 6.01 4.623 6.01zM769.092 184H726.93c-3.77 0-5.394-4.841-2.31-6.988l.131-.091c4.392-2.994 10.156-2.722 10.156-2.722S735.73 158 751.239 158c14.022 0 19.613 13.649 21.63 21.169.655 2.443-1.228 4.831-3.777 4.831zm-322.308-48.659h51.622c4.615 0 6.604-6.021 2.827-8.692l-.16-.113c-5.377-3.724-12.435-3.386-12.435-3.386S487.631 103 468.643 103c-17.167 0-24.013 16.978-26.482 26.331-.802 3.039 1.503 6.01 4.623 6.01zM180.717 164h-35.416c-3.167 0-4.531-4.096-1.94-5.913l.11-.077c3.689-2.533 8.531-2.303 8.531-2.303S152.693 142 165.721 142c11.778 0 16.475 11.549 18.169 17.912.55 2.067-1.031 4.088-3.173 4.088zm23.067 26.341h51.622c4.615 0 6.604-6.021 2.827-8.692a9.177 9.177 0 0 0-.16-.113c-5.377-3.724-12.435-3.386-12.435-3.386S244.631 158 225.643 158c-17.167 0-24.013 16.978-26.482 26.331-.802 3.039 1.503 6.01 4.623 6.01zm319.312 41.775h-69.25c-5.607 0-8.025-7.096-3.435-10.245l.194-.133c6.533-4.39 15.108-3.991 15.108-3.991S466.938 194 490.008 194c11.406 0 20.624 19.058 20.624 19.058s15.515 0 18.083 11.974c.777 3.628-1.826 7.084-5.619 7.084zm-325 .341h-69.25c-5.607 0-8.025-7.096-3.435-10.245l.194-.133c6.533-4.39 15.108-3.991 15.108-3.991s1.225-23.747 24.295-23.747c11.406 0 20.624 19.058 20.624 19.058s15.515 0 18.083 11.974c.777 3.628-1.826 7.084-5.619 7.084zm388.95 2.091h153.529c14.411 0 13.75-11.928 9.042-16.084-4.824-4.26-14.358-2.532-14.358-2.532s-2.838-8.023-12.18-11.929c-8.264-3.455-16.921-1.811-16.921-1.811s0-5.507-5.291-10.067c-5.291-4.561-12.346-4.117-12.346-4.117s-4.85-30.363-37.258-30.363c-32.409 0-36.156 28.589-36.156 28.589s-7.276 0-12.567 4.876-5.953 10.416-5.953 10.416-17.695-2.397-22.928 12.948c-3.119 9.146 3.289 20.074 13.387 20.074z",
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains);
export default __webpack_public_path__ + "static/media/mountains.6bd8177eaa026cb8c8b9e94e1c4bb313.svg";
export { ForwardRef as ReactComponent };